import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=33097b2b&"
import script from "./AppCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=33097b2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports